import { Injectable, inject } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { Database, ref, push, set } from '@angular/fire/database';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private messaging = inject(Messaging);
  private db = inject(Database);

  /** 
   * طلب إذن الإشعارات + جلب FCM token + حفظه في RealTime DB
   */
  async requestPermissionAndSaveToken(): Promise<void> {
    try {
      // حماية لو المتصفح لا يدعم الإشعارات
      if (!('Notification' in window)) {
        console.warn('This browser does not support notifications.');
        return;
      }

      // طلب الإذن من المستخدم
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.warn('User denied notifications permission.');
        return;
      }

      const vapidKey = environment.vapidKey;

      // حماية من وجود VAPID key فاضي
      if (!vapidKey) {
        console.error('❌ Missing VAPID Key in environment file!');
        return;
      }

      // جلب FCM token
      const token = await getToken(this.messaging, { vapidKey });

      if (!token) {
        console.warn('FCM token not generated.');
        return;
      }

      console.log('FCM Token:', token);

      // حفظ التوكن في Realtime Database
      const tokensRef = ref(this.db, 'fcmTokens');
      const newTokenRef = push(tokensRef);

      await set(newTokenRef, {
        token,
        createdAt: Date.now()
      });

      console.log('Token saved successfully in Realtime DB.');
    }

    catch (error) {
      console.error('🔥 Error while requesting permission or saving token:', error);
    }
  }

  /**
   * استقبال الإشعارات أثناء فتح الويب (Foreground Messages)
   */
  listenForegroundMessages(): void {
    onMessage(this.messaging, (payload) => {
      console.log('🔥 Foreground FCM Message Received:', payload);

      // هنا تقدر تعمل toast أو popup
      alert(payload.notification?.title + '\n' + payload.notification?.body);
    });
  }
}
